<template>
  <div class="bg">
    <div class="head">
      <Nav />
    </div>
    <app-main />
  </div>
</template>

<script>
import { AppMain, Nav } from './components'
export default {
  name: 'Layout',
  components: {
    AppMain,
    Nav
  },
  computed: {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.bg {
  width: 100%;
  height: 100%;
}
</style>
